import React from "react";
import ReactDom from "react-dom";
import {Router, browserHistory} from "react-router";
import ReactTransitionGroup from "react-addons-css-transition-group";
import {IntlProvider, addLocaleData} from "react-intl";

import classnames from 'classnames';
import "./static/styles/basic.scss";
import * as ShopRoute from "./config/route-config";
import {System} from "./config/route-fetch";
import {BusinessUtil} from "./utils/BusinessUtil";
import AppUtil from "./utils/app-util";
import StorageUtil from "./utils/storage-util";
import {SystemConst} from "./utils/constant";
import {CommonUtil, InitUtil} from "./utils/common-utils";
import {loadWxConfig} from './utils/WechatUtil';
import HdDialog from "./components/HdDialog/HdDialog";
import YunShlTracker from './utils/yunshl-tracker';
import {
  markMiniProgramRestoreApplied,
  tryRestoreFromMiniProgram
} from './utils/mini-program-auth-sync';
import {
    reportH5MiniAuthState,
    reportH5StorageState
} from './utils/auth-debug-reporter';

import zh from 'react-intl/locale-data/zh';
import es from 'react-intl/locale-data/es';
import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';
import fr from 'react-intl/locale-data/fr';
import ar from 'react-intl/locale-data/ar';
import ru from 'react-intl/locale-data/ru';
import ms from 'react-intl/locale-data/ms';
import vi from 'react-intl/locale-data/vi';
import th from 'react-intl/locale-data/th';
import id from 'react-intl/locale-data/id';
import {Base64} from 'js-base64';

addLocaleData([...zh, ...es,...en, ...de, ...fr, ...ar, ...ru, ...ms, ...vi, ...th, ...id,]);  // 引入多语言环境的数据

import zh_CN from "./locale/zh_CN"; // 中文
import es_ES from "./locale/es_ES"; // 西班牙语
import en_US from "./locale/en_US"; // 英语
import de_DE from "./locale/de_DE"; // 德语
import fr_FR from "./locale/fr_FR"; // 法语
import ar_SA from "./locale/ar_SA"; // 阿拉伯语
import ru_RU from "./locale/ru_RU"; // 俄语
import ms_MY from "./locale/ms_MY"; // 马来语
import vi_VN from "./locale/vi_VN"; // 越南语
import th_TH from "./locale/th_TH"; // 泰语
import id_ID from "./locale/id_ID"; // 印尼语


// 多语言 XIAOMI654321
const messages = {
    'zh': zh_CN,
    'es': es_ES,
    'en': en_US,
    'de': de_DE,
    'fr': fr_FR,
    'ar': ar_SA,
    'ru': ru_RU,
    'ms': ms_MY,
    'vi': vi_VN,
    'th': th_TH,
    'id': id_ID,
};
// 消息提示时间
window.ToastDuration = 1.2;
// 获取账号中心信息
const initAuth = () => {
    // app 版本 17620387339
    if (AppUtil.isApp) {
        InitUtil.cleanShopCache();
    }
    const query = CommonUtil.getSearchFromUrl();
    const companyId = StorageUtil.getItem(SystemConst.companyId);
    reportH5StorageState('APP_INIT', {
        company_id_: query.companyId || companyId,
        mini_auth_exists_: query.auth_code_ ? 1 : 0,
        mp_restore_: query.mp_restore,
        mp_auth_synced_: query.mp_auth_synced,
        mp_restore_failed_: query.mp_restore_failed
    });
    // 新公司清除所有缓存
    if (query.companyId && query.companyId != companyId) {
        reportH5StorageState('COMPANY_ID_CHANGED_CLEAR_CACHE', {
            company_id_: query.companyId,
            old_company_id_: companyId,
            mini_auth_exists_: query.auth_code_ ? 1 : 0
        });
        localStorage.clear();
        sessionStorage.clear();
        window.indexedDB.deleteDatabase('YunshlDB');
    }
    CommonUtil.captureShopCloneEntryCodeFromUrl();
    // webapp登陆跳转
    if (query.auth_code_) {
        reportH5MiniAuthState('URL_AUTH_CODE_PRESENT', {
            company_id_: query.companyId || companyId,
            mini_auth_exists_: 1,
            mp_restore_: query.mp_restore,
            mp_auth_synced_: query.mp_auth_synced
        });
        const cachedToken = StorageUtil.getItem(SystemConst.token);
        const cachedUser = StorageUtil.getItem(SystemConst.mShop_user);
        if ((query.mp_restore || query.mp_auth_synced) && cachedToken && cachedUser) {
            reportH5MiniAuthState('H5_LOCAL_AUTH_EXISTS_SKIP_URL_AUTH_CODE', {
                company_id_: query.companyId || companyId,
                mini_auth_exists_: 1
            });
            query.mp_auth_synced = '1';
            delete query.auth_code_;
            browserHistory.replaceState(null, location.pathname, query);
            return;
        }
        const rawAuthCode = decodeURIComponent(query.auth_code_);
        const loginUser = JSON.parse(Base64.decode(rawAuthCode));
        // 本地保存登录信息
        CommonUtil.saveStorageFormLogin(loginUser, rawAuthCode);
        reportH5MiniAuthState('H5_USE_URL_AUTH_CODE', {
            company_id_: loginUser && loginUser.company_id_,
            mini_auth_exists_: 1
        });
        if (query.mp_restore || query.mp_auth_synced) {
            markMiniProgramRestoreApplied();
        }
        query.mp_auth_synced = '1';

        delete query.auth_code_;
        browserHistory.replaceState(null, location.pathname, query);
        return;
    }
    // 没有auth_code_，且H5本地token/ysUser丢失时，尝试让小程序补auth_code_
    reportH5MiniAuthState('URL_AUTH_CODE_MISSING', {
        company_id_: query.companyId || companyId,
        mini_auth_exists_: 0,
        mp_restore_: query.mp_restore,
        mp_auth_synced_: query.mp_auth_synced,
        mp_restore_failed_: query.mp_restore_failed
    });
    tryRestoreFromMiniProgram();
    // 分享人
    if (query.u) {
        StorageUtil.setItem(SystemConst.shareUserId, query.u, true)
    }
    //分享客户
    if (query.c) {
        StorageUtil.setItem(SystemConst.shareClientId, query.c, true)
    }
    // 删除微信设置信息
    StorageUtil.delItem(SystemConst.wechatData);
};
// 初始化数据
initAuth();

class shopComponent extends React.Component {
    constructor(props) {
        super(props);
        const lang = StorageUtil.getItem(SystemConst.lang);
        this.state = {
            options: {},
            isLogin: false,
            homePageLoaded: false,
            baseSetting: {},
            lang: lang || 'zh', // 本地语言
        };
    }

    componentWillMount() {
        StorageUtil.delItem('stopRemind');
        const query = this.props.location.query;
        const companyId = query.companyId ? parseInt(query.companyId) : StorageUtil.getItem(SystemConst.companyId);
        // 获取登陆用户信息
        const ysUser = StorageUtil.getItem(SystemConst.mShop_user);
        const companyTheme = StorageUtil.getItem(SystemConst.companyTheme);
        if (query.code) {
            //state参数有带V的字符的,是微信授权的-- 没带V的不用进入跑接口,以防在做微信支付也需要用到返回的code时,报code已使用的错误
            if (query.state && query.state.indexOf('V') > -1) {
                console.log('获取微信授权信息', query.code);
                if (!query.order_) {
                    // 获取微信授权信息
                    // InitUtil.getWechatUserInfo(query.code, companyId).then(rs => {
                    //     if (ysUser) {
                    //         this.getLoginData();
                    //     }
                    // });
                }
            }

        }

        // 设置主题色
        CommonUtil.setTheme(companyTheme || (ysUser && ysUser.company_theme_) || 'ffb919');
        // 不存在companyId，跳转登陆
        if (!companyId) {
            // Util.message(`缺少企业id,${location.href}`);
            return;
        }

        // 判断是否体验企业
        const isExperience = BusinessUtil.checkExperience(companyId) ? 1 : 0;
        // 设置体验账号信息
        StorageUtil.setItem(SystemConst.isExperience, isExperience);
        // 更新企业id
        StorageUtil.setItem(SystemConst.companyId, companyId);

        // 体验账号,没有登陆人或者登录人id不等于url新id
        if (isExperience && (!ysUser || ysUser.company_id_ !== companyId)) {
            // 自动登陆体验账号，获取公司设置信息
            CommonUtil.toShopExperience();
        }
        // 性能优化：API请求并行化，使用Promise.all同时发起多个请求
        Promise.all([
            InitUtil.getCompany(companyId),
            InitUtil.getApplicationStatus(companyId) ? Promise.resolve() : Promise.resolve(),
            CommonUtil.initCompanySettingAsync(companyId, StorageUtil.getItem(SystemConst.platformCompanyId)),
            ysUser && !query.code ? this.getLoginDataAsync() : Promise.resolve()
        ]).then(results => {
            const rs = results[0];
            if (rs && rs.status === 1) {
                if (!rs.data.allow_visitor_ && !isExperience && !ysUser) {
                    // 非体验账号不允许游客访问，退出登陆端
                    BusinessUtil.toLogout();
                    return;
                }
                StorageUtil.setItem(SystemConst.companyName, rs.data.name_);
                StorageUtil.setItem(SystemConst.companyTheme, rs.data.theme_);
                // 是否开启国家省市县
                StorageUtil.setItem(SystemConst.enableGlobal, rs.data.enable_global_);
                StorageUtil.setItem(SystemConst.switchLanguageType, rs.data.switch_language_type_);
                // 商城货币类型
                // StorageUtil.setItem(SystemConst.currencySymbol, rs.data.currency_type_ || "¥");
                document.title = rs.data.shop_home_title_ || rs.data.name_;

                // 检查用户是否微信绑定
                if (!query.code && !query.order_) {
                    // CommonUtil.toWechatBind();
                }
                // 集团/店铺购物车分组
                StorageUtil.setItem(SystemConst.enableCartGroupShop, rs.data.enable_group_mall_);
                // 设置国际语言
                this.changeLang(rs.data.language_type_);
                StorageUtil.setItem(SystemConst.languageType, rs.data.language_type_);
                StorageUtil.setItem(SystemConst.rmbExchangeRate, rs.data.rmb_exchange_rate_);
                CommonUtil.setTheme(rs.data.theme_);
                CommonUtil.setStatisticalCode(rs.data.view_count_url_);

            }
        }).catch(error => {
            console.error('初始化请求失败:', error);
        });
        // 获取应用状态（以下请求不依赖上面的结果，可独立执行）
        if (ysUser) {
            InitUtil.getMsgSettingByCompanyId(companyId);
            // 获取客服列表
            InitUtil.getCustomerServiceList();
        }
    }

    componentDidMount() {
        //处理微信分享
        loadWxConfig();
        // 统计代码
        this.createAnalyzeCode();
        // 初始化行为追踪SDK
        this.initBehaviorTracker();
        // 更新页面展示类型和页面滚动节点
        window.addEventListener("setItemEvent", e => {
            if (e.key === SystemConst.BaseSetting) {
                this.setState({
                    baseSetting: JSON.parse(e.newValue)
                })
            }
        });
    }

    // 初始化行为追踪SDK
    initBehaviorTracker() {
        const ysUser = StorageUtil.getItem(SystemConst.mShop_user) || {};
        const companyId = StorageUtil.getItem(SystemConst.companyId);
        YunShlTracker.init({
            batchSize: 10,
            flushInterval: 5000
        });
        // 设置用户信息
        YunShlTracker.setUser(ysUser.id_, ysUser.client_id_, companyId || ysUser.company_id_);
    }


    createAnalyzeCode = () => {
        const companyId = StorageUtil.getItem(SystemConst.companyId);
        if (companyId === 205) {
            var hm = document.createElement("script");
            hm.src = "https://s5.cnzz.com/z_stat.php?id=1277658265&web_id=1277658265";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        }
    };
    getLoginData = () => {
        InitUtil.getCartNumber();
        InitUtil.getClientInfo();
    };
    /**
     * 异步版本的getLoginData（性能优化：返回Promise）
     * @returns Promise
     */
    getLoginDataAsync = () => {
        return new Promise((resolve) => {
            InitUtil.getCartNumber();
            InitUtil.getClientInfo();
            resolve();
        });
    };
    // 切换语言
    changeLang = (lang) => {
        StorageUtil.setItem(SystemConst.lang, lang);
        this.setState({
            lang: lang
        })
    };

    // 只跳转登录页，不调用后端logout（用于登录弹窗的"去登录"按钮）
    toLoginPage() {
        BusinessUtil.toLogout('login', true);  // save=true，保留本地状态不清除
    }

    toLogout() {
        //退出到app
        System.logout(null, (response) => {
            if (response.status === 1) {
                BusinessUtil.toLogout();
            }
        })
    }

    toRegister() {
        //退出到app
        BusinessUtil.toLogout('register', true);
    }

    //隐藏弹窗
    hideDialog() {
        this.setState({options: {}})
    }

    setConfirm(obj) {
        this.setState({
            options: {
                type: "confirm",
                ...obj
            }
        })
    }

    //跳转
    toLink(name, query, state) {
        const entryCode = CommonUtil.getShopCloneEntryCode();
        const nextQuery = {...(query || {})};
        if (entryCode && !nextQuery.entryCode && !nextQuery.entry_code_) {
            nextQuery.entryCode = entryCode;
        }
        this.props.history.pushState(state, name, nextQuery);
    };

    render() {
        const {baseSetting, lang} = this.state;
        const parents = {
            ...this.state,
            changeLang: this.changeLang,
            setConfirm: (obj) => this.setConfirm(obj),
            toLogout: () => this.toLogout(),
            toLogin: () => this.toLogin(),
            toLoginPage: () => this.toLoginPage(),  // 只跳登录页，不调logout
            hideDialog: () => this.hideDialog(),
            toRegister: () => this.toRegister(),
            toLink: (name, query, state) => this.toLink(name, query, state),
            changeHomePageLoaded: (v) => this.changeHomePageLoaded(v),
        };
        const {children, location} = this.props;
        const interval = 500;
        // 获取动画名称
        const transitionName = CommonUtil.getTransitionName(location);

        const pageCls = classnames({
            'page-ios': AppUtil.isIos,
            'page': !AppUtil.isIos,
            'font-reset': baseSetting.font_style_ === 'bold',
        });
        return (
            <section className={pageCls}>
                <IntlProvider locale={lang} messages={messages[lang] || messages['zh']}>
                    <ReactTransitionGroup
                        component="section"
                        transitionName={transitionName}
                        transitionEnterTimeout={interval}
                        transitionLeaveTimeout={interval}>
                        <div key={location.pathname + location.search}>
                            {React.cloneElement(children || null, parents)}
                        </div>
                    </ReactTransitionGroup>
                </IntlProvider>
                <HdDialog options={this.state.options} hideDialog={() => this.hideDialog()}/>
            </section>
        )
    }
}

// 页面离开记录上一次路由
const onLeave = (prevState) => {
    sessionStorage.setItem('prevLocation', JSON.stringify({
        pathname: prevState.location.pathname,
        query: prevState.location.query,
        search: prevState.location.search,
    }));
    // 设置公司title
    document.title = StorageUtil.getItem(SystemConst.companyName);
};
const onEnter = (nextState, replaceState) => {
    const {state, pathname, query, action} = nextState.location;
    const nextQuery = {...query};
    let queryChanged = false;
    const localHistory = StorageUtil.getItem(SystemConst.localHistory, true) || [];
    const historyLen = localHistory.length;
    if (!nextQuery.companyId) {
        // 获取本地companyId
        const companyId = StorageUtil.getItem(SystemConst.companyId);
        if (companyId) {
            nextQuery.companyId = companyId;
            queryChanged = true;
        }
    }
    const entryCode = CommonUtil.getShopCloneEntryCode();
    if (entryCode && !nextQuery.entryCode && !nextQuery.entry_code_) {
        nextQuery.entryCode = entryCode;
        queryChanged = true;
    }
    if (queryChanged) {
        replaceState(state, pathname, nextQuery);
    }
    // 相同路由splice替换
    if (historyLen > 0 && pathname === localHistory[historyLen - 1].pathname) {
        localHistory.splice(historyLen - 1, 1, {state, pathname, query: nextQuery})
    } else {
        localHistory.push({state, pathname, query: nextQuery});
        // 只记录12个路由
        if (historyLen > 12) {
            localHistory.shift()
        }
    }
    StorageUtil.setItem(SystemConst.localHistory, localHistory, true);

};
//遍历返回的route对象，并封装childRoutes所需数组返回
const getChildRoutes = (ChildRoute) => {
    let _arr = [];
    for (let key in ChildRoute) {
        ChildRoute[key].onLeave = onLeave;
        ChildRoute[key].onEnter = onEnter;
        _arr.push(ChildRoute[key]);
    }
    return _arr;
};
const rootRoute = [
    {
        path: '/',
        component: shopComponent,
        indexRoute: ShopRoute.Shop,
        childRoutes: getChildRoutes(ShopRoute)
    },
    {
        path: '/GoodsDetail',
        component: shopComponent,
        indexRoute: ShopRoute.GoodsDetail,
    },
    {
        path: 'shop',
        component: shopComponent,
        indexRoute: ShopRoute.Shop,
        childRoutes: getChildRoutes(ShopRoute)
    }];
//  启动项目
const initApp = () => {
    ReactDom.render(
        <Router routes={rootRoute} history={browserHistory}/>,
        document.getElementById('YsApp'),
        () => {
            if (window.__YSHL_BOOT_READY__) {
                window.__YSHL_BOOT_READY__();
            }
        }
    );
};

// 启动app
initApp();





// WEBPACK FOOTER //
// ./src/app.js